import React, { useState, useEffect } from 'react';
import { ZoomIn, ZoomOut, Maximize } from 'lucide-react';

interface ZoomControlsProps {
  scale: number;
  onZoomIn: () => void;
  onZoomOut: () => void;
  onFullscreen: () => void;
}

export const ZoomControls: React.FC<ZoomControlsProps> = ({
  scale,
  onZoomIn,
  onZoomOut,
  onFullscreen,
}) => {
  const [isVisible, setIsVisible] = useState(false);

  // Trigger animation on mount
  useEffect(() => {
    setIsVisible(true);
  }, []);

  return (
    <div
      style={{
        position: 'absolute',
        bottom: '20px',
        right: '40px',
        zIndex: 1000,
        display: 'flex',
        flexDirection: 'row',
        gap: '8px',
        padding: '6px',
        backgroundColor: 'white',
        borderRadius: '9999px',
        boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06)',
        border: '1px solid rgb(229, 231, 235)',
        fontFamily: 'Inter, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif',
        opacity: isVisible ? 1 : 0,
        transform: isVisible ? 'translateY(0)' : 'translateY(20px)',
        transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
      }}
    >
      {/* Zoom Out */}
      <button
        onClick={onZoomOut}
        title="Zoom Out (Ctrl + Mouse Wheel Down)"
        style={{
          width: '36px',
          height: '36px',
          border: 'none',
          borderRadius: '6px',
          backgroundColor: 'transparent',
          color: 'rgb(107, 114, 128)',
          cursor: 'pointer',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          transition: 'all 0.15s cubic-bezier(0.4, 0, 0.2, 1)',
        }}
        onMouseEnter={(e) => {
          e.currentTarget.style.backgroundColor = 'rgb(249, 250, 251)';
          e.currentTarget.style.color = 'rgb(17, 24, 39)';
        }}
        onMouseLeave={(e) => {
          e.currentTarget.style.backgroundColor = 'transparent';
          e.currentTarget.style.color = 'rgb(107, 114, 128)';
        }}
      >
        <ZoomOut size={18} strokeWidth={1.5} />
      </button>

     {/* Divider */}
      <div
        style={{
          width: '1px',
          height: '24px',
          backgroundColor: 'rgb(229, 231, 235)',
          margin: '6px 4px',
        }}
      />

      {/* Zoom In */}
      <button
        onClick={onZoomIn}
        title="Zoom In (Ctrl + Mouse Wheel Up)"
        style={{
          width: '36px',
          height: '36px',
          border: 'none',
          borderRadius: '6px',
          backgroundColor: 'transparent',
          color: 'rgb(107, 114, 128)',
          cursor: 'pointer',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          transition: 'all 0.15s cubic-bezier(0.4, 0, 0.2, 1)',
        }}
        onMouseEnter={(e) => {
          e.currentTarget.style.backgroundColor = 'rgb(249, 250, 251)';
          e.currentTarget.style.color = 'rgb(17, 24, 39)';
        }}
        onMouseLeave={(e) => {
          e.currentTarget.style.backgroundColor = 'transparent';
          e.currentTarget.style.color = 'rgb(107, 114, 128)';
        }}
      >
        <ZoomIn size={18} strokeWidth={1.5} />
      </button>

     

      {/* Fullscreen */}
      {/* <button
        onClick={onFullscreen}
        title="Toggle Fullscreen"
        style={{
          width: '36px',
          height: '36px',
          border: 'none',
          borderRadius: '6px',
          backgroundColor: 'transparent',
          color: 'rgb(107, 114, 128)',
          cursor: 'pointer',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          transition: 'all 0.15s cubic-bezier(0.4, 0, 0.2, 1)',
        }}
        onMouseEnter={(e) => {
          e.currentTarget.style.backgroundColor = 'rgb(249, 250, 251)';
          e.currentTarget.style.color = 'rgb(17, 24, 39)';
        }}
        onMouseLeave={(e) => {
          e.currentTarget.style.backgroundColor = 'transparent';
          e.currentTarget.style.color = 'rgb(107, 114, 128)';
        }}
      >
        <Maximize size={18} strokeWidth={1.5} />
      </button> */}
    </div>
  );
};
